import React from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Breadcrumbs,
  WysiwygField,
  FadeWrapper,
} from '../../../../components';

import {
  BREADCRUMB_URLS,
} from '../../../../config/constants';

import './style.scss';

const NodePointOfViewDetail = ({ entity }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], '');

  return (
    <article className="NodePointOfViewDetail">
      <Container>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs
              data={[
                { url: BREADCRUMB_URLS.points_of_view[currentLanguage].about_us, title: t('breadcrumbs.about_us') },
                { url: BREADCRUMB_URLS.points_of_view[currentLanguage].overview, title: t('entities.points_of_view') },
                { title: title },
              ]}
            />
          </div>
        </div>
      </Container>

      {/* Start of Preface */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1">
            <div className="Preface">
              <FadeWrapper>
                <div className="Preface__title">
                  <h1>{title}</h1>
                </div>
              </FadeWrapper>
              <FadeWrapper delay={100}>
                <div className="Preface__body">
                  <WysiwygField
                    property="schema:text"
                    html={body}
                  />
                </div>
              </FadeWrapper>
            </div>
          </div>
        </div>
      </Container>
      {/* End of Preface */}

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodePointOfViewDetail;
